export default function ValueProposition() {
  const benefits = [
    {
      icon: "ri-refresh-line",
      title: "Daily Updated Structured Shopping Data",
      description: "Our itaobuyspreadsheet system refreshes daily, ensuring you always access the most current product comparisons and pricing data available in 2026.",
    },
    {
      icon: "ri-bar-chart-2-line",
      title: "Easy Comparison Tables for Better Decisions",
      description: "Built-in comparison tables let you evaluate products side by side, making it effortless to identify the best value across multiple itaobuy sheet categories.",
    },
    {
      icon: "ri-rocket-line",
      title: "Faster Product Discovery Workflow",
      description: "Skip the endless scrolling. Our structured spreadsheet approach organizes thousands of products into intuitive categories for rapid browsing.",
    },
    {
      icon: "ri-brain-line",
      title: "Organized Categories for All Experience Levels",
      description: "Whether you are a first-time browser or an experienced shopper, the itaobuyspreadsheet layout is designed for intuitive navigation across 14 categories.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Safer Browsing with Verified Spreadsheet Tracking",
      description: "All listings pass through structured verification before appearing in our database, giving you confidence in every product reference you explore.",
    },
    {
      icon: "ri-global-line",
      title: "Accessible from Anywhere, Anytime",
      description: "The itaobuy sheet database is accessible across all devices, so you can research products whether you are at home or on the go.",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 text-xs font-label text-foreground-600 tracking-wider uppercase whitespace-nowrap">
            Why Itaobuy Sheet
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Why Thousands Choose<br />
            <span className="italic">itaobuyspreadsheet</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label max-w-[560px] mx-auto">
            Our platform is built for shoppers who value efficiency, organization, and data-driven decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/60 hover:border-secondary-300/50 transition-all duration-300"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 mb-5 group-hover:bg-accent-200/80 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3 leading-snug">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed font-label">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}